import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { DynamicDatePipe } from './pipes/DynamicDate/dynamic-date.pipe';
import { DynamicCurrencyPipe } from './pipes/DynamicCurrency/dynamic-currency.pipe';

@NgModule({
  declarations: [DynamicCurrencyPipe, DynamicDatePipe],
  imports: [CommonModule],
  providers: [CurrencyPipe, DatePipe],
  exports: [DynamicCurrencyPipe, DynamicDatePipe]
})
export class FhPipesModule {}
